import { CustomFieldDefinition, CustomFieldType } from '__types__';
import { TFunction } from 'i18next';
import { Calendar, CalendarRange } from 'lucide-react';
import { customFilter } from 'v5/core/standard-date-filter/custom-filter';
import { FilterDateConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createDateFilterConfig(
  customFieldDef: CustomFieldDefinition,
  t: TFunction<'core'>
): FilterDateConfig<any> {
  return {
    ...customFilter.createFilterConfig(customFieldDef.name, t),
    icon:
      customFieldDef.data_type === CustomFieldType.DATE_RANGE ? (
        <CalendarRange />
      ) : (
        <Calendar />
      )
  };
}
